const $inject = ['$uibModalInstance', 'id'];

const lbaDeleteConfirmCtrl = function ($uibModalInstance, id) {
  let vm = this;

  vm.id = id;

  vm.ok = function () {
    $uibModalInstance.close(vm.id);
  };

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
};


lbaDeleteConfirmCtrl.$inject = $inject;

export default lbaDeleteConfirmCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaGrid/lbaDeleteConfirmCtrl.js